import React from 'react'
import { ReduxFormFieldWrapper, Chip } from '@adc/ui-core'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames/bind'
import { InvestorPreferences } from '../../../../util'
import Search from '../../../search'
import cls from './styles.scss'
const cx = classNames.bind(cls)

const QUESTION_SETS = InvestorPreferences.IP_OBJECT()
const LOOKING_TO_BUY_QUESTION =
  InvestorPreferences.IP_QUESTION_CODE.INV_ONBOARDING_LOOKING_TO_BUY

export const SearchLocationInterest = ({
  value,
  touched,
  error,
  onChange,
  className,
  label,
  elmId,
  placeholder = 'County, City, ZIP',
  includedSuggestionTypes = ['county', 'city', 'zip', 'currentLocation'],
}) => {
  const hasLocationPills = _.isArray(value) && value.length > 0
  const disabled = _.isArray(value) && value.length === 5
  const showError = touched && !!error
  const removeValue = data => () => {
    onChange(_.filter(value, v => !_.isEqual(v, data)))
  }

  const onSearchSubmit = async suggestion => {
    await onChange(
      InvestorPreferences.updateValueBasedOnSuggestion(value, suggestion)
    )
  }

  return (
    <div className={className}>
      <span className={cx('input-label')}>{label}</span>
      <div
        className={cx(
          'search-input',
          showError && 'error',
          disabled && 'disabled'
        )}
      >
        <Search
          disabled={disabled}
          elmId={`${elmId}_onboarding`}
          label='Where I want to buy: (maximum of 5)'
          placeholder={placeholder}
          onSearchSubmit={onSearchSubmit}
          clearInputOnSearch
          includedSuggestionTypes={includedSuggestionTypes}
          categorizeResults
        />
        {hasLocationPills && (
          <div className={cx('location-pills')}>
            {(value || []).map((val, i) => {
              const label = InvestorPreferences.placeToLabel(val)
              return (
                <Chip
                  key={label}
                  className={cx('filter-pills')}
                  elmId={`pill_${i}`}
                  content={label}
                  onClick={removeValue(val)}
                  size='small'
                  type='input'
                  selectionStyle='light'
                />
              )
            })}
          </div>
        )}
      </div>
      {showError && <div className={cx('error-text', 'u-mb-1')}>{error}</div>}
    </div>
  )
}

export default ReduxFormFieldWrapper(fieldProps => {
  const { label = QUESTION_SETS[LOOKING_TO_BUY_QUESTION].label } = fieldProps
  return <SearchLocationInterest {...fieldProps} label={label} />
})

SearchLocationInterest.propTypes = {
  value: PropTypes.array.isRequired,
  touched: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  elmId: PropTypes.string,
  placeholder: PropTypes.string,
  includedSuggestionTypes: PropTypes.array,
}
